import hexagon0 from 'assets/images/hexagon-0-6.svg';
import hexagon1 from 'assets/images/hexagon-1-6.svg';
import hexagon2 from 'assets/images/hexagon-2-6.svg';
import hexagon3 from 'assets/images/hexagon-3-6.svg';
import hexagon4 from 'assets/images/hexagon-4-6.svg';
import hexagon5 from 'assets/images/hexagon-5-6.svg';
import hexagon6 from 'assets/images/hexagon-6-6.svg';
import * as React from 'react';

interface HexagonCompletionProps {
    current: number;
    total: number;
}

export class HexagonCompletion extends React.PureComponent<HexagonCompletionProps> {
    public render() {
        return (
            <div style={{backgroundImage: 'url(' + this.getBackgroundUrl() + ')'}}
                 className='hexagon-completion'>
                <span>{this.props.current} / {this.props.total}</span>
            </div>
        );
    }

    private getBackgroundUrl() {
        let completion = this.props.current * 6 / this.props.total;
        // We always want to round up completion score except
        // when `5 < score < 6` because it will show a full
        // completed hexagon while all work is not done.
        if (5 <= completion && completion < 6) {
            completion = 5;
        } else {
            completion = Math.ceil(completion);
        }
        switch (Math.ceil(this.props.current * 6 / this.props.total)) {
            case (0): {
                return hexagon0;
            }
            case (1): {
                return hexagon1;
            }
            case (2): {
                return hexagon2;
            }
            case (3): {
                return hexagon3;
            }
            case (4): {
                return hexagon4;
            }
            case (5): {
                return hexagon5;
            }
            case (6): {
                return hexagon6;
            }
        }
    }
}
